angular.module('v3sWbtPlayerApp').factory('v3sWbtInfo', ["v3sModal", "$tooltip", "v3sLoaderService", "v3sContentPath", "$templateCache", "$interpolate", "v3sLog", "v3sI18nService", function (v3sModal, $tooltip, v3sLoaderService, v3sContentPath, $templateCache, $interpolate, v3sLog, v3sI18nService) {
    var modal = null;
    var modalScope = null;


    function showModal() {
        var template = $templateCache.get('app/js/helper/wbtInfo/wbtInfo.tpl.html');
        var content = $interpolate(template)(modalScope);

        modal = v3sModal.show({
            title: "dialogs.info.title",
            content: content,
            customClass: "wbtinfo",
            actions: {
                'dialogs.settings.buttons.debuginfo.buttontext': function () {
                    var dbgInfo = v3sLog.getDebugInfo();

                    var ta = document.createElement('textarea');
                    ta.value = dbgInfo;

                    document.body.appendChild(ta);

                    var range = document.createRange();

                    ta.contenteditable = true;
                    ta.readonly = false;
                    range.selectNodeContents(ta);

                    var s = window.getSelection();
                    s.removeAllRanges();
                    s.addRange(range);

                    ta.setSelectionRange(0, 999999);

                    if (!window.getSelection().toString()) {
                        ta.select();
                    }

                    var success = document.execCommand('copy');
                    document.body.removeChild(ta);


                    var btn = document.querySelector('#v3s-form-modal > form > div.modal-footer > span > button');
                    if (btn) {
                        $tooltip(angular.element(btn), { title: v3sI18nService.getText('dialogs.settings.buttons.debuginfo.tooltiptext'), container: '#v3s-form-modal', show: true});
                    }

                }
            },
            onHide: function () {
                modal = null;
            }
        });
    }

    function show() {
        if (!!modal) {
            modal.hide();
            return;
        }

        if (!modalScope) {
            v3sLoaderService('wbtInfo.js', v3sContentPath).then(function (wbtInfo) {
                modalScope = wbtInfo;
                if (!!modalScope.attachmentFile) {
                    modalScope.attachmentFile = v3sContentPath + modalScope.attachmentFile;
                }

                showModal();
            });
        } else {
            showModal();
        }
    }
    
    return {
        show: show
    }

}]);